import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function EventIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4 8.31747C4 7.42237 4.59473 6.63627 5.45609 6.39285L18.4561 2.71893C19.7325 2.35822 21 3.31718 21 4.64355V16.4654C21 17.758 19.7921 18.7112 18.5349 18.4105L5.53485 15.3018C4.63484 15.0866 4 14.282 4 13.3567V8.31747Z" fill={props.fill} />
			<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M5 9H4C2.89543 9 2 9.89543 2 11C2 12.1046 2.89543 13 4 13H5V9ZM6.02991 15.2425L7.43991 20.8825C7.60409 21.5393 8.19418 22 8.87113 22C9.85018 22 10.5576 21.0638 10.2904 20.122L8.96206 15.4413L8.19553 15.6588L7.97019 14.7575L6.02991 15.2425Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<EventIcon fill={props.fill} />
		</div>
	);
}